module.exports = __webpack_public_path__ + "static/media/information.cdf32cbe.svg";